export enum ToastrActionEnum {
  Success = 'success',
  Info = 'info',
  Error = 'error',
  Warning = 'warning',
}

export enum ToastrStringsEnum {
  Downloading = 'DOWNLOADING',
  DownloadDone = 'DLDONE',
  Uploading = 'UPLOADING',
  UploadDone = 'ULDONE',
  Converting = 'CONVERTING',
  ConversionDone = 'CONVERTDONE',
  ConversionFailed = 'CONVERTFAIL',
  OpeningDedicon = 'OPENINGDEDICON',
  PrepareDoc = 'PREPAREPAGE',
  PageHasNoText = 'PAGEHASNOTEXT',
  SpellcheckWordIsLong = 'SPELLCHECKWORDISLONG',
  CloudError = 'CLOUDERROR',
  CloudConnectionSuccess = 'CLOUDCONNECTIONSUCCESS',
  FavoriteAdd = 'FAVORITEADD',
  FavoriteRemove = 'FAVORITEREMOVE',
  FeatureTemplateSaveSuccess = 'FEATURETEMPLATESAVESUCCESS',
  // FeatureTemplateSaveError = 'FEATURETEMPLATESAVEERROR',
  // FeatureTemplateDeleteError = 'FEATURETEMPLATEDELETEERROR',
  ExamSaveSuccess = 'EXAMSAVESUCCESS',
  // ExamSaveError = 'EXAMSAVEERROR',
  // CodeError = 'CODEERROR',
  ExamDeleteSuccess = 'EXAMDELETESUCCESS',
  OCRFailedPasswordNeeded = 'OCRFAILPWD',
  OCRFailedPDFTronError = 'OCRFAILPDFTRON',
  ProcessingTextMap = 'PROCESSINGTEXTMAP',
  EpubAnnotationPositionUnavailable = 'EPUBANNOTATIONPOSITIONUNAVAILABLE',
}
